import { useEffect, useState } from "react";

import {
  getGoldBotPositions,
  isPositionsRequestCanceled,
} from "../services/goldBotPositionsApi";

export const GOLD_BOT_POSITIONS_POLL_INTERVAL_MS = 5000;

export function useGoldBotPositions() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;
    let activeController = null;

    const loadPositions = async () => {
      activeController?.abort();
      const controller = new AbortController();
      activeController = controller;

      try {
        const positions = await getGoldBotPositions({
          signal: controller.signal,
        });
        if (isActive) {
          setData(positions);
          setError(null);
        }
      } catch (requestError) {
        if (isActive && !isPositionsRequestCanceled(requestError)) {
          setError(requestError);
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    loadPositions();
    const pollInterval = window.setInterval(
      loadPositions,
      GOLD_BOT_POSITIONS_POLL_INTERVAL_MS
    );

    return () => {
      isActive = false;
      window.clearInterval(pollInterval);
      activeController?.abort();
    };
  }, []);

  return { data, error, isLoading };
}
